import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Stack,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PeopleIcon from "@mui/icons-material/People";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CategoryIcon from "@mui/icons-material/Category";

const links = [
  {
    title: "Tenants",
    description: "Create and manage organizations on the platform.",
    to: "/admin/tenants",
    icon: <ApartmentIcon fontSize="large" color="primary" />,
  },
  {
    title: "Users",
    description: "View and manage users across the platform.",
    to: "/admin/users",
    icon: <PeopleIcon fontSize="large" color="primary" />,
  },
  {
    title: "Invites",
    description: "Send and track onboarding invitations.",
    to: "/admin/invites",
    icon: <MailOutlineIcon fontSize="large" color="primary" />,
  },
  {
    title: "Roles",
    description: "Configure roles and permissions.",
    to: "/admin/roles",
    icon: <CategoryIcon fontSize="large" color="primary" />,
  },
];

export default function SuperAdminDashboard() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Stack spacing={0.5} sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={800}>
          Platform administration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage tenants, users, invitations, and roles. Animal records are
          managed within each organization.
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        {links.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.to}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardContent
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                }}
              >
                <Box>{item.icon}</Box>
                <Typography variant="subtitle1" fontWeight={700}>
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ flex: 1 }}
                >
                  {item.description}
                </Typography>
                <Button
                  variant="contained"
                  component={RouterLink}
                  to={item.to}
                  fullWidth
                  sx={{ mt: 1 }}
                >
                  Open
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
